// services/orderMutationApiSlice.js
import { apiSlice } from "../apiSlice";

export const orderMutationApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    updateOrder: builder.mutation({
      query: ({ id, patchData }) => ({
        url: `orders/${id}`,
        method: "PATCH",
        body: patchData,
      }),
      invalidatesTags: (result, error, { id }) => [{ type: "Orders", id }],
    }),
    updateShipmentStatus: builder.mutation({
      query: ({ orderId, id, status }) => ({
        url: `orders/${orderId}`,
        method: "PATCH",
        body: { id, status },
      }),
      invalidatesTags: (result, error, { orderId }) => [
        { type: "Orders", id: orderId },
      ],
    }),
  }),
});

export const {
  useUpdateOrderMutation,
  useUpdateShipmentStatusMutation,
} = orderMutationApiSlice;
